import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { MessageCircle, Handshake, ShoppingCart } from "lucide-react";

const WA_NUMBER = "5588988676142";

const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export default function DetailModal({ item, onClose }) {
  if (!item) return null;
  const isLive = item.isLive;

  const titleText = item.title || "";
  const contratarMsg = `Olá! Quero contratar o UniPlay HD. Vi o título: "${titleText}". Pode me passar os planos?`;
  const afiliadoMsg = `Olá! Tenho interesse em ser afiliado/revendedor do UniPlay HD. Pode me explicar como funciona?`;

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl p-0 bg-[#0d0d11] border-white/10 text-white overflow-hidden">
        <div className="grid md:grid-cols-[320px_1fr]">
          {/* Poster column */}
          <div className="relative aspect-[2/3] md:aspect-auto bg-black">
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d11] via-transparent to-transparent md:bg-gradient-to-r md:from-transparent md:to-[#0d0d11]/40 pointer-events-none" />
            {isLive && (
              <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-600 text-white text-xs font-bold">
                <span className="w-2 h-2 rounded-full bg-white pulse-dot" /> AO VIVO
              </div>
            )}
            {!isLive && (
              <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-600 text-white text-[10px] font-bold uppercase tracking-wider">
                {item.type || "Filme"}
              </div>
            )}
          </div>

          {/* Info column */}
          <div className="p-6 md:p-8 flex flex-col">
            <div className="text-xs text-red-500 font-bold uppercase tracking-widest">
              {item.type || "Filme"} {item.subtitle && <span className="text-white/40">• {item.subtitle}</span>}
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold mt-1">{item.title}</h2>
            {item.description ? (
              <p className="text-white/70 mt-3 max-w-3xl">{item.description}</p>
            ) : (
              <p className="text-white/65 mt-3 max-w-3xl">
                Esse título faz parte do nosso catálogo. Para assistir agora mesmo em sua Smart TV, TV Box, Celular ou Computador, contrate o UniPlay HD pelo WhatsApp e tenha acesso a milhares de filmes, séries, novelas e canais ao vivo.
              </p>
            )}

            <div className="mt-4 grid sm:grid-cols-3 gap-3 text-sm">
              <div><span className="text-white/40">Direção:</span> <span className="text-white/85">A definir</span></div>
              <div><span className="text-white/40">Elenco:</span> <span className="text-white/85">Em breve</span></div>
              <div><span className="text-white/40">Gênero:</span> <span className="text-white/85">Variado</span></div>
            </div>

            <div className="mt-6 rounded-2xl bg-gradient-to-br from-[#16210f] to-[#0d160a] border border-[#25D366]/20 p-4">
              <div className="flex items-center gap-2 text-[#25D366] text-xs font-bold uppercase tracking-wider mb-2">
                <MessageCircle className="w-4 h-4" /> Atendimento via WhatsApp
              </div>
              <p className="text-white/70 text-sm">
                Escolha uma das opções abaixo para falar diretamente com nossa equipe.
              </p>

              <div className="mt-4 grid sm:grid-cols-2 gap-3">
                <a
                  href={waLink(contratarMsg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#25D366] hover:brightness-110 text-white font-bold shadow-lg shadow-[#25D366]/30 transition"
                >
                  <ShoppingCart className="w-4 h-4" /> CONTRATAR
                </a>
                <a
                  href={waLink(afiliadoMsg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-white/8 hover:bg-white/12 text-white font-bold border border-[#25D366]/40 transition"
                >
                  <Handshake className="w-4 h-4 text-[#25D366]" /> SEJA AFILIADO
                </a>
              </div>
            </div>

            <p className="mt-4 text-[11px] text-white/40">
              Resposta rápida pelo WhatsApp +55 88 9.8867-6142 • Atendimento humanizado
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
